<template>
  <div class="list-container">
    <div class="news-top">
      <carousel :list="bannerList"/>
    </div>
    <div class="news-main">
      <div class="news-nav">
        <div class="news-nav-list">
          <router-link to="/" class="news-nav-first">首页</router-link>
          <span class="news-nav-mark">>></span>
          <router-link to="/news" class="news-nav-first">新闻动态</router-link>
          <span class="news-nav-mark">>></span>
          <span class="news-nav-current">新闻列表</span>
        </div>
      </div>
      <div class="news-list">
        <div class="news-item" v-for="item in newsList" :key="item.id">
          <div class="news-item-box">
            <imgContainer :src="item.cover" />
          </div>
          <div class="news-item-info">
            <div>
              <div class="item-info-name">
                <div class="info-name-mark">
                  <div v-show="item.headlines == 1" class="info-name-tou">头条</div>
                  <div class="info-name-title" @click="handleDetails(item.id)">{{ handleChara(item.title, 20) }}</div>
                </div>
                <div class="info-name-time">{{ formatDayYYYYMMDD(item.createTime) }}</div>
              </div>
              <div class="info-instructions">
                {{ handleChara(item.introduction, 200) }}
              </div>
            </div>
            <div class="item-info-btn" @click="handleDetails(item.id)">查看详情</div>
          </div>
        </div>
      </div>
      <div class="news-pagination" v-if="page.total > 5">
        <el-config-provider :locale="modifiedZhCn">
          <el-pagination
            v-model:current-page="page.pageNum"
            v-model:page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-config-provider>
      </div>
    </div>
  </div>
</template>

<script setup>
import carousel from '@/components/carousel/index.vue'
import {handleChara} from "@/utils/title";
import {formatDayYYYYMMDD} from "@/utils/day";
import {reactive, ref} from "vue";
import {ElConfigProvider,ElPagination} from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import router from "@/router";
import {getEnterpriseList} from "@/api/apiNews";
import {getBannerList} from "@/api/apiHome";
import imgContainer from '@/components/imgContainer/index.vue'

const modifiedZhCn = { ...zhCn };
modifiedZhCn.el.pagination.goto = "前往"
modifiedZhCn.el.pagination.pageClassifier='页'
const newsList = ref([])
const bannerList = ref([])
const loading = ref(false)
const handleDetails = (id) => {
  router.push('/newsDetails?id=' + id)
}
const page = reactive({
  pageNum: 1,
  pageSize: 6
})
const queryNewsList = async (currentPage) => {
  loading.value = true;
  if (currentPage) {
    page.pageNum = currentPage;
  }
  try {
    const {code, data} = await getEnterpriseList(page)
    if (code === 200) {
      const {records, total} = data || {};
      newsList.value = records || [];
      page.total = total
    }
  } catch (error) {
    newsList.value = [];
  } finally {
    loading.value = false;
  }
}
const queryBannerList = async () => {
  const {code, data} = await getBannerList(5)
  if (code === 200) {
    bannerList.value = data
  }
}
// 分页相关：监听页码切换事件
const handleCurrentChange = (val) => {
  page.pageNum = val
  queryNewsList(val)
}
// 分页相关：监听单页显示数量切换事件
const handleSizeChange = (val) => {
  page.pageSize = val
  queryNewsList(1)
}
queryNewsList(1)
queryBannerList()
</script>

<style lang="scss" scoped>

.news-top {
  width: 100%;
  height: 450px;
  overflow: hidden;
}

.news-main {
  width: 1200px;
  margin: 0 auto 70px auto;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}

.news-nav {
  width: 100%;
  height: 36px;
}

.news-nav-list {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.news-nav-first {
  margin: 0 10px;
  font-size: 16px;
  color: #242424;
}

.news-nav-mark {
  margin: 0 14px;
  font-size: 16px;
  font-weight: bold;
  color: #242424;
}

.news-nav-current {
  font-size: 16px;
  color: #0048A9;
}

.news-item {
  display: flex;
  margin-bottom: 30px;
}

.news-item-box {
  width: 409px;
  height: 211px;
}

.news-item-info {
  margin-left: 30px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.item-info-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-name-mark {
  display: flex;
  align-items: center;
}

.info-name-tou {
  width: 42px;
  height: 27px;
  text-align: center;
  line-height: 27px;
  background: #FF8F21;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  margin-right: 10px;
}

.info-name-title {
  font-weight: bold;
  font-size: 24px;
  color: #0048A9;
  cursor: pointer;
}

.info-name-time {
  font-size: 18px;
  color: #797979;
}

.info-instructions {
  font-size: 18px;
  color: #797979;
  margin-top: 20px;
}

.item-info-btn {
  font-size: 18px;
  color: #0048A9;
  cursor: pointer;
}

.news-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>
